import { Grid } from '@material-ui/core';
import { Audit, ChangeReason, Disagreement, Person, Worksheet, addDisagreement, addRebuttalDisagreement, auditRecord, resolutionForIteration } from '../domain';

import Cancel from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { withTooltip } from '../format';
import { orignalGreen, origninalRed } from '../theme';
import { VisitCode } from '../visit-context';
import { openAuditRebuttalAction } from './audit-rebuttal';
import { RebuttalAction } from './audit-rebuttal-model';
import { setDisagreements } from '../worksheets';

type DisagreementBadgeProps = {
  disagreement: Disagreement;
  nDisagreements: number;
  index: number;
  onAction(action: RebuttalAction): void;
};

function DisagreementBadge({ index, nDisagreements, onAction }: DisagreementBadgeProps) {
  const i = (index || 0) + 1;
  const odd = i % 2 === 1;
  const first = i === 1;
  const final = i === 4;
  const label = final ? 'Final' : odd ? 'C' + i : 'A' + i;

  const disabled = i <= nDisagreements;
  const action = (a: RebuttalAction) => {
    if (disabled) return undefined;
    return () => {
      onAction(a);
    };
  };

  const cursor = disabled ? undefined : { cursor: 'pointer' };
  const agreeTooltip = final ? 'Resolve' : i === 2 ? 'Revert' : 'Agree';
  const disagreeTooltip = final ? 'Revert' : 'Disagree';

  return (
    <Grid
      item
      container
      direction="column"
      style={{
        flexWrap: 'nowrap',
        borderLeft: index !== 0 ? 'solid 1px #ccc' : undefined,
        maxWidth: 48,
        width: 48,
        paddingLeft: 3,
        paddingRight: 0,
        opacity: disabled ? 0.4 : 1,
      }}
    >
      <Grid item container alignContent="center">
        <span style={{ margin: 'auto', color: '#aaa' }}>{label}</span>
      </Grid>

      <Grid item container direction="row" style={{ flexWrap: 'nowrap', width: 48 }}>
        <Grid item onClick={!first && action('Agree')} style={cursor}>
          {disabled || first ? <CheckCircleIcon htmlColor={first ? '#ccc' : orignalGreen} /> : withTooltip(agreeTooltip, <CheckCircleIcon htmlColor={orignalGreen} />)}
        </Grid>
        <Grid item onClick={action('Disagree')} style={cursor}>
          {disabled ? <Cancel htmlColor={origninalRed} /> : withTooltip(disagreeTooltip, <Cancel htmlColor={origninalRed} />)}
        </Grid>
      </Grid>
    </Grid>
  );
}

type RebuttalHistoryProps = {
  audit: Audit;
  map: Audit;
  onActionComplete: (action: RebuttalAction) => void;
  worksheet?: Worksheet;
  reasons?: VisitCode[];
  workflow?: string;
  action: RebuttalAction;
  user?: Person;
};

export function RebuttalHistory({ workflow, audit, map, worksheet, reasons, user, onActionComplete }: RebuttalHistoryProps) {
  if (!audit?.disagreementReasons?.length) {
    setDisagreements(audit, [], workflow, audit.lineId, worksheet.rebuttalIteration || 1);
  }
  const list = audit.disagreementReasons || [];

  const nDisagreements = list.length - 1;

  function updateLastDisagreement(reason: ChangeReason, a: RebuttalAction) {
    audit.disagreementReasons.pop();
    const d = reason.disagreementReasons[reason.disagreementReasons.length - 1];
    d.agree = a === 'Agree';
    audit.disagreementReasons.push(d);
    reason.disagreementReasons = audit.disagreementReasons;
    if (onActionComplete) {
      onActionComplete(a);
    }
  }
  const lineId = audit.lineId;
  function onAction(a: RebuttalAction) {
    const { disagreementResolved, reverted } = resolutionForIteration(nDisagreements + 1, a);

    console.info('resolution', a);

    let reason: ChangeReason;

    console.info('RebuttalAction', a);

    if (a === 'Agree') {
      audit.resolved = true;

      reason = { ...(map.changeReasons[map.changeReasons.length - 1] || {}) };
      reason.comments = 'Resolved';
      reason.changeReasonDescription = reason.changeReasonDescription || '';
      reason.sourceObject = audit.sourceObject || map.sourceObject || reason.sourceObject;
      reason = addDisagreement(lineId, map, reason, workflow, user, disagreementResolved, reverted);

      updateLastDisagreement(reason, a);
      addRebuttalDisagreement(worksheet, workflow, reason);

      return;
    }

    openAuditRebuttalAction({
      title: `${a} Audit Action`,
      existing: audit,
      list: (reasons || audit?.changeReasons || []) as any,
      onComplete: (update: Audit) => {
        if (workflow) {
          console.info('Rebuttal Action', update);
          worksheet.auditInfo = auditRecord(workflow, worksheet.auditInfo);

          switch (a) {
            case 'Disagree': {
              reason = addDisagreement(lineId, map, update, workflow, user, disagreementResolved, reverted);
              addRebuttalDisagreement(worksheet, workflow, reason);
              break;
            }
          }
        } else {
          console.info('RebuttalActionLink - no workflow', update);
        }

        if (reason) {
          updateLastDisagreement(reason, a);
        }
      },
    });
  }

  return (
    <Grid container direction="row" spacing={0} style={{ flexWrap: 'nowrap' }}>
      <Grid item style={{ flexGrow: 1 }} />
      {list.map((disagreement, index) => {
        return <DisagreementBadge key={index} index={index} disagreement={disagreement} nDisagreements={nDisagreements} onAction={onAction} />;
      })}
    </Grid>
  );
}
